import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66e80d68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article" }
const _hoisted_2 = { class: "side left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-emphasize" }, "In this article", -1))
const _hoisted_4 = {
  class: "main-content",
  ref: "markdownElement"
}
const _hoisted_5 = { class: "side right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArticleMap = _resolveComponent("ArticleMap")!
  const _component_MarkdownRenderer = _resolveComponent("MarkdownRenderer")!
  const _component_AboutTheAuthor = _resolveComponent("AboutTheAuthor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_ArticleMap, {
        sections: _ctx.sections,
        "active-section-id": _ctx.activeSectionId,
        onSectionClicked: _ctx.scrollSectionIntoView
      }, null, 8, ["sections", "active-section-id", "onSectionClicked"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.markdown)
        ? (_openBlock(), _createBlock(_component_MarkdownRenderer, {
            key: 0,
            markdown: _ctx.markdown,
            onLoaded: _ctx.markdownLoaded
          }, null, 8, ["markdown", "onLoaded"]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_AboutTheAuthor, { class: "about-the-author" })
    ])
  ]))
}